import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { Content, Step } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const {
  CONTENT,
  CHECK_SYMPTOMS,
  BOOK_APPOINTMENT,
  PRESCRIPTION,
  CONFIG_WITH_ELIGIBILITY,
} = USA
const { WELCOME, REGISTRATION, SUMMARY, ELIGIBILITY } = CONTENT

const partnerName = 'Presbyterian UltraFlex Medicare Advantage B360'

const welcomeContent: Step = {
  ...WELCOME.enUS,
  copy: [
    'As a Presbyterian Health Plan member, you can talk to a doctor and manage your health right from your phone, at no extra cost. Data rates may apply.',
  ],
}

const content: Content = {
  'en-US': {
    steps: [
      {
        ...welcomeContent,
        productFeatures: [
          {
            ...CHECK_SYMPTOMS.enUS,
          },
          {
            ...BOOK_APPOINTMENT.enUS,
            title:
              'Unlimited virtual doctor and therapist appointments, at a time that best fits your schedule, for you or your dependents.',
          },
          {
            ...PRESCRIPTION.enUS,
            title:
              'Get prescriptions sent to a local pharmacy of your choice (restrictions may apply)',
          },
        ],
      },
      {
        ...REGISTRATION.enUS,
        copy: ['Enter your details to register'],
      },
      ELIGIBILITY.enUS,
      SUMMARY.enUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
}

const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_ELIGIBILITY,
    id: 'presbyterian-ultra-flex-medicare-advantage-b-360',
    productConfigAppName: 'presbyterian-ultra-flex-medicare-advantage-b-360',
    name: partnerName,
    codes: {
      membership: 'PHPUFAUTOAPP',
    },
    partnerUrlSlug: 'phpuf',
  },
  content,
}

const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
  content,
}

export default [baseConfig, baseConfigWithDnaV2Design]
